import { render, staticRenderFns } from "./ClientTable.vue?vue&type=template&id=bcae18a4&scoped=true&"
import script from "./ClientTable.vue?vue&type=script&lang=js&"
export * from "./ClientTable.vue?vue&type=script&lang=js&"
import style0 from "./ClientTable.vue?vue&type=style&index=0&id=bcae18a4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bcae18a4",
  null
  
)

export default component.exports